export enum DiscountTypes {
  Value = 1,
  Percentage = 2
}
